import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import thunk from "redux-thunk";
import welcomeScreenReducer from "../reducers/welcomeScreenSlice";
import formReducer from "../reducers/formSlice";
import companyScreenReducer from "../reducers/companyInformationSlice";
import companyDetailsReducer from "../reducers/companyDetailsSlice";
import contactInformationReducer from "../reducers/contactInformationSlice";
import finalDetailsReducer from "../reducers/finalDetailsSlice";
import socialSelectModalReducer from "../reducers/socialSelectModalSlice";
import thankYouReducer from "../reducers/thankYouSlice";
import companyDuplicateModalReducer from "../reducers/companyDuplicateModalSlice";
import taxNumberInvalidModalReducer from "../reducers/taxNumberInvalidModal";
import languageOptionsReducer from "../reducers/languageOptionsSlice";
import addContactPersonReducer from "../reducers/addContactPersonSlice";
import headerAndFooterReducer from "../reducers/headerAndFooterSlice";
import loadingScreenReducer from "../reducers/loadingScreenSlice";
import errorManagementReducer from "../reducers/errorManagementSlice";
import salesforceLeadIdReducer from "../reducers/salesforceLeadIdSlice";

const persistConfig = {
  key: "root",
  storage: storageSession,
};

const languagePersistConfig = {
  key: "language",
  storage: storageSession,
};

const persistedFormReducer = persistReducer(persistConfig, formReducer);

const persistedLanguageOptionsReducer = persistReducer(
  languagePersistConfig,
  languageOptionsReducer
);

export const store = configureStore({
  reducer: {
    welcomeScreen: welcomeScreenReducer,
    companyInformationScreen: companyScreenReducer,
    companyDetailsScreen: companyDetailsReducer,
    contactInformationScreen: contactInformationReducer,
    finalDetailsScreen: finalDetailsReducer,
    socialSelectModal: socialSelectModalReducer,
    thankYouScreen: thankYouReducer,
    companyDuplicateModal: companyDuplicateModalReducer,
    taxNumberInvalidModal: taxNumberInvalidModalReducer,
    addContactPersonScreen: addContactPersonReducer,
    form: persistedFormReducer,
    languageOptions: persistedLanguageOptionsReducer,
    headerAndFooter: headerAndFooterReducer,
    loadingScreen: loadingScreenReducer,
    errorManagement: errorManagementReducer,
    salesForceLeadId: salesforceLeadIdReducer,
  },
  devTools: process.env.REACT_APP_ENV !== "PROD",
  middleware: [thunk],
});

export const persistor = persistStore(store);
